import { Component, OnInit, Inject, AfterViewInit, ChangeDetectorRef, Output, EventEmitter, Input } from '@angular/core';
import { AUTHORIZATOR_CONFIG } from '../../authorizator.config.token';
import { AuthorizatorConfig } from '../../authorizator.config';
import { ResourceObj } from '../../classes/resource-obj';
import { Operation, PermissionObj } from '../../classes/permission-obj';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBarConfig, MatSnackBar } from '@angular/material/snack-bar';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { UserObj } from '../../classes/user-obj';
import { BehaviorSubject } from 'rxjs';
import { AuthorizatorService } from '../../services/authorizator.service';
import { RoleObj } from '../../classes/role-obj';

export interface PermissionData {
  rootFirebasePath: string;
  user?: UserObj;
  role?: RoleObj;
}

@Component({
  selector: 'lib-permission-manager',
  templateUrl: './permission-manager.component.html',
  styleUrls: ['./permission-manager.component.scss']
})
export class PermissionManagerComponent implements OnInit, AfterViewInit {
  public permissionsConfig: {
    resource: ResourceObj,
    operations: { id: Operation, value: boolean}[]
  }[];
  public AllowedOperation = Operation;
  public resourceCols = 5;
  public permissionCols = 5;
  public user: UserObj;
  public role: RoleObj;

  @Output() change: EventEmitter<PermissionObj> = new EventEmitter<PermissionObj>();
  constructor(
    @Inject(AUTHORIZATOR_CONFIG) private authorizatorConfig: AuthorizatorConfig, private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: PermissionData,
    private authorizatorservice: AuthorizatorService,
    private snackbar: MatSnackBar
  ) {
    this.user = data.user;
    this.role = data.role;
  }

  ngOnInit() {
    if (this.authorizatorConfig && this.authorizatorConfig.permissions) {
      this.permissionsConfig = this.authorizatorConfig.permissions.map(permission => {
        return {
          resource: permission.resource,
          operations: permission.allowedOperations.map(operation => {
            return {
              id: operation,
              value:
                this.user ?
                  (
                    this.user.data.permissions ?
                    (
                      this.user.data.permissions.find(perm => perm.resource === permission.resource.id) ?
                      (
                        this.user.data.permissions.find(
                          perm => perm.resource === permission.resource.id
                        ).operations.findIndex(oper => oper === operation) > -1
                      ) : false
                    ) : false
                  ) :
                this.role ?
                  (
                    this.role.data.permissions ?
                    (
                      this.role.data.permissions.find(perm => perm.resource === permission.resource.id) ?
                      (
                        this.role.data.permissions.find(
                          perm => perm.resource === permission.resource.id
                        ).operations.findIndex(oper => oper === operation) > -1
                      ) : false
                    ) : false
                  ) : false
            };
          })
        };
      });
    } else {
      console.error(`Configuration of module missing, please add the next code in the Module declaration:
      AngularFirebaseAuthorizatorModule.forRoot({
        permissions: [
          {
            resource: {
              id: 'someid',
              data: {
                description: 'Resource description'
              }
            },
            allowedOperations: [
              Operation.Create,
              Operation.Read,
              Operation.Update,
              Operation.Delete,
              Operation.Deny
            ]
          }
        ]
      })`);
    }
  }

  ngAfterViewInit() {
    if (this.permissionsConfig) {
      const permissionManagerWidth = document.getElementById('permission_manager_container').offsetWidth;
      if (permissionManagerWidth <= 400) {
        this.resourceCols = 5;
        this.permissionCols = 5;
      } else if (permissionManagerWidth > 400 && permissionManagerWidth <= 600) {
        this.resourceCols = 6;
        this.permissionCols = 4;
      } else if (permissionManagerWidth > 600 && permissionManagerWidth <= 800) {
        this.resourceCols = 7;
        this.permissionCols = 3;
      } else {
        this.resourceCols = 8;
        this.permissionCols = 2;
      }
    }
    this.cd.detectChanges();
  }

  onPermissionChange(resource: ResourceObj, operation: Operation, event: MatSlideToggleChange) {
    const updatePermissionsMonitor: BehaviorSubject<PermissionObj[]> = new BehaviorSubject<PermissionObj[]>(null);
    const permissions =
      this.user ? this.user.data.permissions || [] :
      this.role ? this.role.data.permissions || [] : [];
    const permissionIndex: number = permissions.findIndex(permission => permission.resource === resource.id);
    if (event.checked) {
      if (permissionIndex > -1) {
        const operationIndex: number = permissions[permissionIndex].operations.findIndex(oper => oper === operation);
        if (operationIndex === -1) {
          permissions[permissionIndex].operations.push(operation);
          updatePermissionsMonitor.next(permissions);
        }
      } else {
        permissions.push({
          resource: resource.id,
          operations: [operation]
        });
        updatePermissionsMonitor.next(permissions);
      }
    } else {
      if (permissionIndex > -1) {
        const operationIndex: number = permissions[permissionIndex].operations.findIndex(oper => oper === operation);
        if (operationIndex > -1) {
          if (permissions[permissionIndex].operations.length > 1) {
            permissions[permissionIndex].operations.splice(operationIndex, 1);
          } else {
            permissions.splice(permissionIndex, 1);
          }
          updatePermissionsMonitor.next(permissions);
        }
      }
    }
    updatePermissionsMonitor.subscribe(permissionsToUpdate => {
      if (permissionsToUpdate) {
        if (this.user) {
          const userToUpdate: UserObj = this.data.user;
          userToUpdate.data.permissions = permissionsToUpdate;
          const config: MatSnackBarConfig = new MatSnackBarConfig();
          config.duration = 2000;
          this.authorizatorservice.updateUserPermissions(this.data.rootFirebasePath, userToUpdate).then(() => {
            config.panelClass = ['success-bar'];
            this.snackbar.open('Permissions updated', null, config);
          }).catch(error => {
            config.panelClass = ['error-bar'];
            this.snackbar.open(error.message, null, config);
          });
        }
        if (this.role) {
          const roleToUpdate: RoleObj = this.data.role;
          roleToUpdate.data.permissions = permissionsToUpdate;
          const config: MatSnackBarConfig = new MatSnackBarConfig();
          config.duration = 2000;
          this.authorizatorservice.updateRolePermissions(this.data.rootFirebasePath, roleToUpdate).then(() => {
            config.panelClass = ['success-bar'];
            this.snackbar.open('Permissions updated', null, config);
          }).catch(error => {
            console.log('ban5');
            console.log(error);
            config.panelClass = ['error-bar'];
            this.snackbar.open(error.message, null, config);
          });
        }
        updatePermissionsMonitor.unsubscribe();
      }
    });
  }
}
